import Badge from "../../../../../styles/customComponents/Badge";
import "./SingleProgram.css";
import moment from "moment";

const ProgDATA = ({ programme }) => {
  const countDisponibleLots = (programme) => {
    return programme.lots.filter(
      (lot) => lot.disponibility?.disponibilite === "Disponible"
    ).length;
  };
  return (
    <div className="progDATA w70 d-flex flex-column gap20">
      {/* Top Section using Grid */}
      <div className="infos d-flex flex-column gap20">
        {/* First Row Grid */}
        <div className="grid-container">
          {/* 2fr column */}
          <div className="grid-item d-flex flex-column gap10">
            <h1 className="semibold fs26 darkGrey">{programme?.name}</h1>
            <p className="darkGrey fs21 regular">
              {programme?.promoteur?.name || "promoteur"}
            </p>
            <p className="darkGrey fs21 semibold">{programme?.address}</p>
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex justify-content-center align-items-center">
            <img
              src="./assets/imgNotFound.webp"
              alt="Coffim"
              className="radius5 promoteurLogo"
            />
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex justify-content-center">
            <div className="position-relative text-center">
              <img
                src="./assets/progress.png"
                alt="prog_owner"
                className="radius5"
              />
              <span className="progression-programme">
                {programme?.progress != null ? `${programme?.progress}%` : "NC"}
              </span>
              <p>Écoulement</p>
            </div>
          </div>

          {/* 1fr column */}
          <div className="grid-item">
            <div className="d-flex justify-content-between align-items-center fs16 regular h100">
              <div className="d-flex flex-column">
                <p>Lots</p>
                <p>Dispo</p>
                <p>Optionnés</p>
              </div>
              <div className="d-flex flex-column text-end">
                <p>{programme?.lots.length}</p>
                <p>{countDisponibleLots(programme)}</p>
                <p>{programme?.lots.length - countDisponibleLots(programme)}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="separator"></div>

        {/* Second Row Grid */}
        <div className="grid-container">
          {/* 2fr column */}
          <div className="grid-item d-flex flex-column gap20">
            <div className="adresse">
              <p className="regular fs21 darkgrey">{programme?.address}</p>
              <p className="semibold fs21 darkgrey">
                Zone {programme?.zone_fiscale || "NC"}
              </p>
            </div>
            <div className="d-flex flex-column gap10 w-max">
              <div className="">
                <Badge
                  label="Droit commun"
                  BadgeClass="bg-green px-3 py-2 white radius5 medium fs17"
                />
              </div>
              <div className="d-flex gap10">
                <Badge
                  label="PTZ"
                  BadgeClass="bg-pink px-3 py-2 white radius5 medium fs17"
                />
                <Badge
                  label="RP neuf"
                  BadgeClass="bg-oyster px-3 py-2 white radius5 medium fs17"
                />
              </div>
            </div>
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/key.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Livraison</p>
            <p className="semibold fs17 pink">
              {programme?.delivery_date
                ? moment(programme?.delivery_date).format("YYYY") +
                  " T-" +
                  moment(programme?.delivery_date).quarter()
                : "Non Précisée"}
            </p>
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/hand.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Actabilité</p>
            <p className="semibold fs17 pink">
              {programme?.actibility_date != null
                ? moment(programme?.actibility_date).format("YYYY") +
                  " T-" +
                  moment(programme?.actibility_date).quarter()
                : programme?.is_actable
                ? "Immédiate"
                : "Non Précisée"}
            </p>
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/bill.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Mandat interne</p>
            <p className="semibold fs17 pink">NC</p>
          </div>
        </div>
      </div>

      <div className="separator"></div>

      {/* Description Section */}
      <div className="progDescription">
        <p className="progDescriptionTitle semibold fs14 darkGrey">
          Description
        </p>
        <p className="progDescriptiontext mt-3">
          {programme?.description || "Non Précisée"}
        </p>
      </div>
    </div>
  );
};

export default ProgDATA;
